export const columnKeyMap = {
  address: 'address',
  name: 'name',
  account: 'account',
  accountMark: 'accountMark',
  houseType: 'houseType',
  tenantMark: 'tenantMark',
  aliveClientCount: 'aliveClientCount',
  alive: 'alive',
  porchCount: 'porchCount',
  flatCount: 'flatCount',
  clientCount: 'clientCount',
  houseStageName: 'houseStageName',
  flat: 'address.name',
  addressStageName: 'stageAddressLifeCycle',
  addressStepName: 'stepAddressLifeCycle',
  addressSaleName: 'saleAddressLifeCycle',
  flatAcceptanceResult: 'acceptanceStatusAddressLifeCycle',
  debt: 'debt',
  immediateRequest: 'immediateRequest',
  activeRequest: 'activeRequest',
  tenantCount: 'tenantCount',
  registrationType: 'registrationType',
  openDate: 'openDate',
  closeDate: 'closeDate',
  accessType: 'hasAccessType',
  fio: 'fio',
  verificationDate: 'verificationDate',
  isVerified: 'isVerified',
  region: 'regionId',
  existLayout: 'existLayout',
};
